import { v4 as uuidv4 } from 'uuid';

const generateUUIDWithoutHyphens = () => {
  const uuid = uuidv4(); 
  const cleanUUID = uuid.replace(/-/g, ''); 
  return cleanUUID;
};
  export const generateRandomDataWithDelay = () => {
    return generateUUIDWithoutHyphens();
  };